var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "searchBox_top" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "acl",
                  rawName: "v-acl",
                  value: _vm.MaterialEdit,
                  expression: "MaterialEdit",
                },
              ],
              attrs: {
                size: "mini",
                type: "primary",
                disabled: _vm.preventManyClick,
              },
              on: { click: _vm.save },
            },
            [_vm._v(_vm._s(_vm.$t("common.save")))]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.historyBack },
            },
            [_vm._v(_vm._s(_vm.$t("common.close")))]
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticClass: "materialForm",
          staticStyle: { "margin-top": "10px" },
          attrs: { "label-width": "200px", model: _vm.materialForm },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.eightBitCode.eightBitCode"),
                        prop: "eightBitCode",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.materialForm.eightBitCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.materialForm, "eightBitCode", $$v)
                          },
                          expression: "materialForm.eightBitCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.eightBitCode.eightBitCodeName"),
                        prop: "eightBitCodeName",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.materialForm.eightBitCodeName,
                          callback: function ($$v) {
                            _vm.$set(_vm.materialForm, "eightBitCodeName", $$v)
                          },
                          expression: "materialForm.eightBitCodeName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "base.material.foutboundFreightTaxAmount"
                        ),
                        prop: "foutboundFreightTaxAmount",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          clearable: "",
                          oninput: "if(value.length>20)value=value.slice(0,20)",
                        },
                        model: {
                          value: _vm.materialForm.foutboundFreightTaxAmount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.materialForm,
                              "foutboundFreightTaxAmount",
                              $$v
                            )
                          },
                          expression: "materialForm.foutboundFreightTaxAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.material.foutboundFreightwotax"),
                        prop: "foutboundFreightwotax",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          clearable: "",
                          oninput: "if(value.length>20)value=value.slice(0,20)",
                        },
                        model: {
                          value: _vm.materialForm.foutboundFreightwotax,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.materialForm,
                              "foutboundFreightwotax",
                              $$v
                            )
                          },
                          expression: "materialForm.foutboundFreightwotax",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.material.foutboundFreightwtax"),
                        prop: "foutboundFreightwtax",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          clearable: "",
                          oninput: "if(value.length>20)value=value.slice(0,20)",
                        },
                        model: {
                          value: _vm.materialForm.foutboundFreightwtax,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.materialForm,
                              "foutboundFreightwtax",
                              $$v
                            )
                          },
                          expression: "materialForm.foutboundFreightwtax",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.material.fstorageFeeTaxAmount"),
                        prop: "fstorageFeeTaxAmount",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          clearable: "",
                          oninput: "if(value.length>20)value=value.slice(0,20)",
                        },
                        model: {
                          value: _vm.materialForm.fstorageFeeTaxAmount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.materialForm,
                              "fstorageFeeTaxAmount",
                              $$v
                            )
                          },
                          expression: "materialForm.fstorageFeeTaxAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.material.fstorageFeewotax"),
                        prop: "fstorageFeewotax",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          clearable: "",
                          oninput: "if(value.length>20)value=value.slice(0,20)",
                        },
                        model: {
                          value: _vm.materialForm.fstorageFeewotax,
                          callback: function ($$v) {
                            _vm.$set(_vm.materialForm, "fstorageFeewotax", $$v)
                          },
                          expression: "materialForm.fstorageFeewotax",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.material.fstorageFeewtax"),
                        prop: "fstorageFeewtax",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          clearable: "",
                          oninput: "if(value.length>20)value=value.slice(0,20)",
                        },
                        model: {
                          value: _vm.materialForm.fstorageFeewtax,
                          callback: function ($$v) {
                            _vm.$set(_vm.materialForm, "fstorageFeewtax", $$v)
                          },
                          expression: "materialForm.fstorageFeewtax",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.material.ftransportFeeTaxAmount"),
                        prop: "ftransportFeeTaxAmount",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          clearable: "",
                          oninput: "if(value.length>20)value=value.slice(0,20)",
                        },
                        model: {
                          value: _vm.materialForm.ftransportFeeTaxAmount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.materialForm,
                              "ftransportFeeTaxAmount",
                              $$v
                            )
                          },
                          expression: "materialForm.ftransportFeeTaxAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.material.ftransportFeewotax"),
                        prop: "ftransportFeewotax",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          clearable: "",
                          oninput: "if(value.length>20)value=value.slice(0,20)",
                        },
                        model: {
                          value: _vm.materialForm.ftransportFeewotax,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.materialForm,
                              "ftransportFeewotax",
                              $$v
                            )
                          },
                          expression: "materialForm.ftransportFeewotax",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.material.ftransportFeewtax"),
                        prop: "ftransportFeewtax",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          clearable: "",
                          oninput: "if(value.length>20)value=value.slice(0,20)",
                        },
                        model: {
                          value: _vm.materialForm.ftransportFeewtax,
                          callback: function ($$v) {
                            _vm.$set(_vm.materialForm, "ftransportFeewtax", $$v)
                          },
                          expression: "materialForm.ftransportFeewtax",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.material.storageFeeTaxAmount"),
                        prop: "storageFeeTaxAmount",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          clearable: "",
                          oninput: "if(value.length>20)value=value.slice(0,20)",
                        },
                        model: {
                          value: _vm.materialForm.storageFeeTaxAmount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.materialForm,
                              "storageFeeTaxAmount",
                              $$v
                            )
                          },
                          expression: "materialForm.storageFeeTaxAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.material.storageFeewotax"),
                        prop: "storageFeewotax",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          clearable: "",
                          oninput: "if(value.length>20)value=value.slice(0,20)",
                        },
                        model: {
                          value: _vm.materialForm.storageFeewotax,
                          callback: function ($$v) {
                            _vm.$set(_vm.materialForm, "storageFeewotax", $$v)
                          },
                          expression: "materialForm.storageFeewotax",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.material.storageFeewtax"),
                        prop: "storageFeewtax",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          clearable: "",
                          oninput: "if(value.length>20)value=value.slice(0,20)",
                        },
                        model: {
                          value: _vm.materialForm.storageFeewtax,
                          callback: function ($$v) {
                            _vm.$set(_vm.materialForm, "storageFeewtax", $$v)
                          },
                          expression: "materialForm.storageFeewtax",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.material.transportFeeTaxAmount"),
                        prop: "transportFeeTaxAmount",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          clearable: "",
                          oninput: "if(value.length>20)value=value.slice(0,20)",
                        },
                        model: {
                          value: _vm.materialForm.transportFeeTaxAmount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.materialForm,
                              "transportFeeTaxAmount",
                              $$v
                            )
                          },
                          expression: "materialForm.transportFeeTaxAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.material.transportFeewotax"),
                        prop: "transportFeewotax",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          clearable: "",
                          oninput: "if(value.length>20)value=value.slice(0,20)",
                        },
                        model: {
                          value: _vm.materialForm.transportFeewotax,
                          callback: function ($$v) {
                            _vm.$set(_vm.materialForm, "transportFeewotax", $$v)
                          },
                          expression: "materialForm.transportFeewotax",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("base.material.transportFeewtax"),
                        prop: "transportFeewtax",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          clearable: "",
                          oninput: "if(value.length>20)value=value.slice(0,20)",
                        },
                        model: {
                          value: _vm.materialForm.transportFeewtax,
                          callback: function ($$v) {
                            _vm.$set(_vm.materialForm, "transportFeewtax", $$v)
                          },
                          expression: "materialForm.transportFeewtax",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "action-btn-row" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "acl",
                  rawName: "v-acl",
                  value: _vm.MaterialEdit,
                  expression: "MaterialEdit",
                },
              ],
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.addDC },
            },
            [_vm._v(_vm._s(_vm.$t("common.add")))]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "acl",
                  rawName: "v-acl",
                  value: _vm.MaterialEdit,
                  expression: "MaterialEdit",
                },
              ],
              attrs: { size: "mini", type: "danger" },
              on: { click: _vm.delDC },
            },
            [_vm._v(_vm._s(_vm.$t("common.del")))]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "dcsData",
          attrs: { data: _vm.dcsData, border: "", "highlight-current-row": "" },
        },
        [
          _c("el-table-column", { attrs: { type: "selection" } }),
          _c("el-table-column", {
            attrs: {
              sortable: "",
              label: _vm.$t("base.dc.dcName"),
              prop: "tmDcId",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("ic-select", {
                      attrs: {
                        "table-fields": [{ table: "BASE", field: "DC" }],
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: scope.row.tmDcId,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "tmDcId", $$v)
                        },
                        expression: "scope.row.tmDcId",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { sortable: "", label: _vm.$t("base.material.dcTime") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: {
                        type: "number",
                        clearable: "",
                        oninput: "if(value.length>20)value=value.slice(0,20)",
                      },
                      model: {
                        value: scope.row.dcTime,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "dcTime", $$v)
                        },
                        expression: "scope.row.dcTime",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { sortable: "", label: _vm.$t("base.material.spTime") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: {
                        type: "number",
                        clearable: "",
                        oninput: "if(value.length>20)value=value.slice(0,20)",
                      },
                      model: {
                        value: scope.row.spTime,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "spTime", $$v)
                        },
                        expression: "scope.row.spTime",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { sortable: "", label: _vm.$t("base.material.icTime") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: {
                        type: "number",
                        clearable: "",
                        oninput: "if(value.length>20)value=value.slice(0,20)",
                      },
                      model: {
                        value: scope.row.icTime,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "icTime", $$v)
                        },
                        expression: "scope.row.icTime",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }